<div class="program-arithmetic card">
  <h4
    *ngIf="programNode?.labelText || programNode?.name"
    [innerHTML]="programNode?.labelText || programNode?.name"
  ></h4>
  <span
    class="label-highlight"
    *ngIf="programNode?.description"
    [innerHTML]="programNode?.description"
  ></span>
  <span
    *ngIf="programNode?.sentenceValue"
    [innerHTML]="programNode?.sentenceValue"
  ></span>
</div>
